import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CommonSuccesModalPageRoutingModule } from './common-succes-modal-routing.module';

import { CommonSuccesModalPage } from './common-succes-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommonSuccesModalPageRoutingModule
  ],
  declarations: [CommonSuccesModalPage]
})
export class CommonSuccesModalPageModule {}
